 <template>
  <div class="invite">
    <div class="headerCard">
      <div class="header">
        <div class="text">可提现收入(元)</div>
        <div class="detail" @click="data.goDetail()">
          查看明细<img src="@/assets/invite_right.png" alt="" />
        </div>
      </div>
      <div class="price">
        <div class="num">{{ inviteStore.teamInfo.commission_balance }}</div>
        <div class="withdrawCash" @click="data.goWithdrawDeposit()">提现</div>
      </div>
      <div class="faceplate">
        <div class="item">
          <div class="title">累计收入(元)</div>
          <div class="num">{{ inviteStore.teamInfo.total_commission }}</div>
        </div>
        <div class="item">
          <div class="title">团队成员(个)</div>
          <div class="num">{{ inviteStore.teamInfo.total_team }}</div>
        </div>
      </div>
    </div>
    <div class="main" :class="store.isSafari?'isSafariClass':''">
      <div class="award">
        <div class="title">
          团长奖励
          <span
            >名下团员付费
            <img
              @click="inviteStore.setInviteTipDialogFlag(true)"
              src="@/assets/inviteTip.png"
              alt=""
          /></span>
        </div>
        <div class="expense">
          <div class="items">
            <div class="item">
              <div class="title">一级团员付费</div>
              <div class="centen">
                提成<span>{{ inviteStore.teamInfo.one_ratio }}%</span>
              </div>
            </div>
            <div class="item">
              <div class="title">二级团员付费</div>
              <div class="centen">
                提成<span>{{ inviteStore.teamInfo.two_ratio }}%</span>
              </div>
            </div>
          </div>
          <div class="btn" @click="data.goInviteCards()">立即邀请</div>
        </div>
      </div>
      <div class="member">
        <div class="title">
          我的团员
          <span
            >有效团员共{{
              inviteStore.teamInfo.one_sum + inviteStore.teamInfo.two_sum
            }}个</span
          >
        </div>
        <div class="memberList">
          <div
            class="item"
            :class="inviteStore.quitMemberItem === 'levelOne' ? 'quitItem' : ''"
            @click="inviteStore.setQuitMemberItem('levelOne')"
          >
            <span>一级团员({{ inviteStore.teamInfo.one_sum }})</span>
          </div>
          <div
            class="item"
            :class="inviteStore.quitMemberItem === 'levelTwo' ? 'quitItem' : ''"
            @click="inviteStore.setQuitMemberItem('levelTwo');"
          >
            <span>二级团员({{ inviteStore.teamInfo.two_sum }})</span>
          </div>
        </div>
        <div class="cardList">
          <div v-for="item in inviteStore.teamUserList" :key="item.id">
            <div class="card">
              <div class="header">
                <div class="iphone">{{ item.phone }}</div>
                <div class="spread" v-if="inviteStore.quitMemberItem === 'levelOne'">
                  推广<span>{{ item.subordinates_count }}</span
                  >人
                </div>
              </div>
              <div class="order">
                <div class="orderNum">{{ item.count_order }}个订单</div>
                <div class="prcieNum">{{ item.sum_commission }}元</div>
              </div>
              <div class="bindingTime">绑定时间:{{ item.ctime }}</div>
            </div>
          </div>

          <div
            class="search"
            v-if="inviteStore.teamUserList.length !== 0"
            @click="data.goList"
          >
            查看更多<img src="@/assets/inviteBottom.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <van-dialog
    className="inviteDialogClass"
    v-model:show="inviteStore.inviteTipDialogFlag"
    :showConfirmButton="false"
  >
    <div class="title">提示</div>
    <div class="centen">1.邀请的一级团员付费成功后，可获得15%的提成奖励；</div>
    <div class="centen">
      2.由一级团员邀请的二级团员付费成功后，可获得5%的提成奖励。
    </div>
    <div class="btn" @click="inviteStore.setInviteTipDialogFlag(false)">
      知道了
    </div>
  </van-dialog>
</template>

<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  watchEffect,
  computed,
  defineComponent,
  defineExpose,
} from "vue";
import { useCounterStore } from "@/store";
import { useRoute, useRouter } from "vue-router";
import { useInviteStore } from "@/store/invite";
const store = useCounterStore();

defineComponent({
  name: "invite",
});

const inviteStore = useInviteStore();

/**
 * 路由对象
 */
const route = useRoute();
/**
 * 路由实例
 */
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
 * 数据部分
 */
const data = reactive({});

data.goList = () => {
  router.push({
    path: "/memberList",
  });
};

data.goDetail = () => {
  router.push({
    path: "/detail",
  });
};

data.goInviteCards = () => {
  router.push({
    path: "/InviteCards",
  });
};

data.goWithdrawDeposit = () => {
  router.push({
    path: "/withdrawDeposit",
  });
};

onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
});
onMounted(() => {
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
});
watchEffect(() => {});
// 使用toRefs解构
// let { } = { ...toRefs(data) }
defineExpose({
  ...toRefs(data),
});
</script>
<style lang="scss" scoped>
.invite {
  .headerCard {
    margin: 24px;
    background: linear-gradient(125deg, #8e92fd 0%, #b1b5fe 47%, #b8a9fa 100%);
    border-radius: 24px;
    .header {
      display: flex;
      justify-content: space-between;
      padding: 0 24px;
      padding-top: 24px;
      padding-bottom: 28px;
      align-items: center;
      color: #f7f5ff;
      font-size: 28px;
      .detail {
        font-size: 26px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 44px;
          height: 44px;
        }
      }
    }
    .price {
      display: flex;
      align-items: center;
      color: #ffffff;
      padding: 0 32px;
      padding-bottom: 32px;
      border-bottom: 1px solid #f7f5ff80;
      .num {
        font-size: 64px;
        font-weight: bold;
        font-family: DINAlternate-Bold, DINAlternate;
      }
      .withdrawCash {
        font-size: 28px;
        font-weight: 300;
        background: #8368fc;
        border-radius: 16px;
        padding: 10px 40px;
        margin-left: 32px;
      }
    }
    .faceplate {
      display: flex;
      padding: 32px 0;
      .item {
        position: relative;
        flex: 1;
        text-align: center;
        color: #ffffff;
        .title {
          font-size: 26px;
        }
        .num {
          margin-top: 12px;
          font-size: 32px;
          font-weight: bold;
          font-family: DINAlternate-Bold, DINAlternate;
        }
      }
      .item:first-child:after {
        content: "";
        width: 1px;
        height: 60px;
        background: #f7f5ff80;
        position: absolute;
        top: 20px;
        right: 0;
      }
    }
  }
  .isSafariClass {
    height: calc(100vh - 650px) !important;
  }
  .main {
    margin: 0 24px;
    border-radius: 24px;
    background: #1d2234;
    height: calc(100vh - 550px);
    overflow: hidden;
    overflow-y: auto;
    .title {
      padding: 24px;
      font-size: 32px;
      font-weight: 500;
      color: #ffffff;
      display: flex;
      span {
        margin-left: 16px;
        font-weight: 400;
        color: #f7f5ff80;
        font-size: 26px;
        display: flex;
        align-items: center;
        img {
          width: 28px;
          height: 28px;
        }
      }
    }
    .award {
      .expense {
        padding-bottom: 48px;
        border-bottom: 1px solid #f7f5ff80;
        .items {
          display: flex;
          .item {
            position: relative;
            flex: 1;
            text-align: center;
            font-size: 28px;
            font-weight: 300;
            color: #ffffff;
            .title {
              font-size: 28px;
              font-weight: 300;
              display: block;
              padding: 0;
            }
            .centen {
              span {
                color: #8368fcff;
              }
            }
          }
          .item:first-child::after {
            content: "";
            height: 60px;
            width: 1px;
            position: absolute;
            right: 0;
            top: 10px;
            background: #f7f5ff80;
          }
        }
        .btn {
          margin: 0 157px;
          margin-top: 32px;
          padding: 15px 0;
          text-align: center;
          background: #8368fc;
          border-radius: 16px;
          font-size: 30px;
          font-weight: 500;
          color: #ffffff;
        }
      }
    }
    .member {
      .memberList {
        display: flex;
        .item {
          flex: 1;
          text-align: center;
          color: #f7f5ff80;
          font-size: 26px;
          font-weight: 300;
        }
        .quitItem {
          font-weight: 400;
          color: #ffffff;
          span {
            position: relative;
          }
          span::after {
            position: absolute;
            left: 32px;
            content: "";
            width: 64px;
            background: #8368fc;
            border-radius: 4px;
            height: 4px;
            bottom: -8px;
          }
        }
      }
      .cardList {
        margin-top: 28px;
        .card {
          background: #323647;
          border-radius: 16px;
          margin: 0 24px;
          margin-top: 20px;
          padding-top: 24px;
          .header {
            padding: 0 24px;
            font-weight: 500;
            color: #ffffff;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .iphone {
              font-size: 30px;
            }
            .spread {
              font-size: 28px;
              span {
                color: #8368fcff;
              }
            }
          }
          .order {
            margin-top: 8px;
            padding: 0 24px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 20px;
            border-bottom: 1px solid #f7f5ff30;
            .orderNum {
              color: #f7f5ff80;
            }
            .prcieNum {
              color: #ffffff;
            }
          }
          .bindingTime {
            padding: 16px 24px;
            color: #f7f5ff60;
            font-size: 24px;
          }
        }
        .search {
          display: flex;
          justify-content: center;
          align-items: center;
          color: #ffffff;
          font-size: 28px;
          margin-top: 26px;
          margin-bottom: 64px;
          img {
            width: 44px;
            height: 44px;
          }
        }
      }
    }
  }
  .main::-webkit-scrollbar {
    width: 0 !important;
  }
}
</style>
